import { defineMessages } from 'react-intl';

export default defineMessages({
  alertText: {
    id: 'RefundRequestedAlert.alertText',
    defaultMessage: 'This discretionary refund was requested by {agent} at {time} on {date}',
  },
});
